import { USER_SUCCESS, USER_LOGOUT } from '../actions/user'

// `localStorage` only stores strings: saving a field the API did not send
// used to persist the literal "undefined", which the header then displayed
// as "undefined undefined". Both sides are now normalised to an empty string.
const isBlank = value => value === undefined || value === null || value === ''

const readUserItem = key => {
  const value = localStorage.getItem(key)
  if (isBlank(value) || value === 'undefined' || value === 'null') {
    // Also cleans up what previous versions have already written
    localStorage.removeItem(key)
    return ''
  }
  return value
}

const writeUserItem = (key, value) => {
  if (isBlank(value)) {
    localStorage.removeItem(key)
    return ''
  }
  localStorage.setItem(key, value)
  return value
}

const state = {
  userGroups: readUserItem('ops-x1jets-user-group'),
  userFirstName: readUserItem('ops-x1jets-user-first_name'),
  userLastName: readUserItem('ops-x1jets-user-last_name'),
  userUsername: readUserItem('ops-x1jets-user-username'),
}

const getters = {
  getUserGroups: state => state.userGroups,
  getUserFirstName: state => state.userFirstName,
  getUserLastName: state => state.userLastName,
  getUserUsername: state => state.userUsername,

}

const actions = {
  [USER_LOGOUT]: ({commit}) => {
    commit(USER_LOGOUT)
  }
}

const mutations = {
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    const groups = resp.groups ? JSON.stringify(resp.groups) : ''
    state.userGroups = writeUserItem('ops-x1jets-user-group', groups)
    state.userFirstName = writeUserItem('ops-x1jets-user-first_name', resp.first_name)
    state.userLastName = writeUserItem('ops-x1jets-user-last_name', resp.last_name)
    state.userUsername = writeUserItem('ops-x1jets-user-username', resp.username)
  },
  [USER_LOGOUT]: (state) => {
    state.userGroups = ''
    localStorage.removeItem('ops-x1jets-user-group')
    state.userFirstName = ''
    localStorage.removeItem('ops-x1jets-user-first_name')
    state.userLastName = ''
    localStorage.removeItem('ops-x1jets-user-last_name')
    state.userUsername = ''
    localStorage.removeItem('ops-x1jets-user-username')
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
